// extracted by mini-css-extract-plugin
export default {"root":"ReMh6z8Wmm13tRY5kRir"};